export default __webpack_public_path__ + "static/media/home-profile.1825cd17.jpg";